// tslint:disable
/**
 * Labor Protection API (Russian)
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { Worker } from '../models';
import { WorkerImport } from '../models';
import { WorkerImportList } from '../models';
import { WorkerList } from '../models';
/**
 * WorkerApi - axios parameter creator
 * @export
 */
export const WorkerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} protocolId 
         * @param {string} registrationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorker(protocolId: string, registrationId: string, options: any = {}): RequestArgs {
            // verify required parameter 'protocolId' is not null or undefined
            if (protocolId === null || protocolId === undefined) {
                throw new RequiredError('protocolId','Required parameter protocolId was null or undefined when calling deleteWorker.');
            }
            // verify required parameter 'registrationId' is not null or undefined
            if (registrationId === null || registrationId === undefined) {
                throw new RequiredError('registrationId','Required parameter registrationId was null or undefined when calling deleteWorker.');
            }
            const localVarPath = `/labor-protection/ru/worker/{protocolId}/{registrationId}`
                .replace(`{${"protocolId"}}`, encodeURIComponent(String(protocolId)))
                .replace(`{${"registrationId"}}`, encodeURIComponent(String(registrationId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImportWorker(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getImportWorker.');
            }
            const localVarPath = `/labor-protection/ru/workers/import/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} protocolId 
         * @param {string} registrationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorker(protocolId: string, registrationId: string, options: any = {}): RequestArgs {
            // verify required parameter 'protocolId' is not null or undefined
            if (protocolId === null || protocolId === undefined) {
                throw new RequiredError('protocolId','Required parameter protocolId was null or undefined when calling getWorker.');
            }
            // verify required parameter 'registrationId' is not null or undefined
            if (registrationId === null || registrationId === undefined) {
                throw new RequiredError('registrationId','Required parameter registrationId was null or undefined when calling getWorker.');
            }
            const localVarPath = `/labor-protection/ru/worker/{protocolId}/{registrationId}`
                .replace(`{${"protocolId"}}`, encodeURIComponent(String(protocolId)))
                .replace(`{${"registrationId"}}`, encodeURIComponent(String(registrationId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {WorkerImport} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importWorkers(body: WorkerImport, options: any = {}): RequestArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling importWorkers.');
            }
            const localVarPath = `/labor-protection/ru/workers/imports`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {string} [companyId] 
         * @param {Array<'waiting' | 'started' | 'success' | 'fail'>} [statuses] 
         * @param {Date} [startedAtMin] 
         * @param {Date} [startedAtMax] 
         * @param {Date} [finishedAtMin] 
         * @param {Date} [finishedAtMax] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {'startedAt' | 'finishedAt' | 'createdAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listImportsWorkers(ids?: Array<string>, companyId?: string, statuses?: Array<'waiting' | 'started' | 'success' | 'fail'>, startedAtMin?: Date, startedAtMax?: Date, finishedAtMin?: Date, finishedAtMax?: Date, createdAtMin?: Date, createdAtMax?: Date, sort?: 'startedAt' | 'finishedAt' | 'createdAt', order?: 'ASC' | 'DESC', offset?: number, limit?: number, options: any = {}): RequestArgs {
            const localVarPath = `/labor-protection/ru/workers/imports`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (ids) {
                localVarQueryParameter['ids'] = ids.join(COLLECTION_FORMATS.csv);
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (statuses) {
                localVarQueryParameter['statuses'] = statuses.join(COLLECTION_FORMATS.csv);
            }

            if (startedAtMin !== undefined) {
                localVarQueryParameter['startedAtMin'] = (startedAtMin as any).toISOString();
            }

            if (startedAtMax !== undefined) {
                localVarQueryParameter['startedAtMax'] = (startedAtMax as any).toISOString();
            }

            if (finishedAtMin !== undefined) {
                localVarQueryParameter['finishedAtMin'] = (finishedAtMin as any).toISOString();
            }

            if (finishedAtMax !== undefined) {
                localVarQueryParameter['finishedAtMax'] = (finishedAtMax as any).toISOString();
            }

            if (createdAtMin !== undefined) {
                localVarQueryParameter['createdAtMin'] = (createdAtMin as any).toISOString();
            }

            if (createdAtMax !== undefined) {
                localVarQueryParameter['createdAtMax'] = (createdAtMax as any).toISOString();
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] List of strings in format &#x60;{protocolId}--{registrationId}&#x60;, separated by &#x60;--&#x60;. Example: &#x60;546d53af-52ef-4ce5-a2f6-0ee19b668d19--6aaca3b5-6526-48c5-b092-4ba89be8f77e&#x60; 
         * @param {string} [companyId] 
         * @param {Array<string>} [protocolIds] 
         * @param {Array<string>} [registrationIds] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkers(ids?: Array<string>, companyId?: string, protocolIds?: Array<string>, registrationIds?: Array<string>, offset?: number, limit?: number, options: any = {}): RequestArgs {
            const localVarPath = `/labor-protection/ru/workers`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (ids) {
                localVarQueryParameter['ids'] = ids.join(COLLECTION_FORMATS.csv);
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (protocolIds) {
                localVarQueryParameter['protocolIds'] = protocolIds.join(COLLECTION_FORMATS.csv);
            }

            if (registrationIds) {
                localVarQueryParameter['registrationIds'] = registrationIds.join(COLLECTION_FORMATS.csv);
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkerApi - functional programming interface
 * @export
 */
export const WorkerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} protocolId 
         * @param {string} registrationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorker(protocolId: string, registrationId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = WorkerApiAxiosParamCreator(configuration).deleteWorker(protocolId, registrationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImportWorker(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkerImport> {
            const localVarAxiosArgs = WorkerApiAxiosParamCreator(configuration).getImportWorker(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} protocolId 
         * @param {string} registrationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorker(protocolId: string, registrationId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Worker> {
            const localVarAxiosArgs = WorkerApiAxiosParamCreator(configuration).getWorker(protocolId, registrationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {WorkerImport} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importWorkers(body: WorkerImport, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkerImport> {
            const localVarAxiosArgs = WorkerApiAxiosParamCreator(configuration).importWorkers(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {string} [companyId] 
         * @param {Array<'waiting' | 'started' | 'success' | 'fail'>} [statuses] 
         * @param {Date} [startedAtMin] 
         * @param {Date} [startedAtMax] 
         * @param {Date} [finishedAtMin] 
         * @param {Date} [finishedAtMax] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {'startedAt' | 'finishedAt' | 'createdAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listImportsWorkers(ids?: Array<string>, companyId?: string, statuses?: Array<'waiting' | 'started' | 'success' | 'fail'>, startedAtMin?: Date, startedAtMax?: Date, finishedAtMin?: Date, finishedAtMax?: Date, createdAtMin?: Date, createdAtMax?: Date, sort?: 'startedAt' | 'finishedAt' | 'createdAt', order?: 'ASC' | 'DESC', offset?: number, limit?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkerImportList> {
            const localVarAxiosArgs = WorkerApiAxiosParamCreator(configuration).listImportsWorkers(ids, companyId, statuses, startedAtMin, startedAtMax, finishedAtMin, finishedAtMax, createdAtMin, createdAtMax, sort, order, offset, limit, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] List of strings in format &#x60;{protocolId}--{registrationId}&#x60;, separated by &#x60;--&#x60;. Example: &#x60;546d53af-52ef-4ce5-a2f6-0ee19b668d19--6aaca3b5-6526-48c5-b092-4ba89be8f77e&#x60; 
         * @param {string} [companyId] 
         * @param {Array<string>} [protocolIds] 
         * @param {Array<string>} [registrationIds] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkers(ids?: Array<string>, companyId?: string, protocolIds?: Array<string>, registrationIds?: Array<string>, offset?: number, limit?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkerList> {
            const localVarAxiosArgs = WorkerApiAxiosParamCreator(configuration).listWorkers(ids, companyId, protocolIds, registrationIds, offset, limit, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * WorkerApi - factory interface
 * @export
 */
export const WorkerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} protocolId 
         * @param {string} registrationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorker(protocolId: string, registrationId: string, options?: any) {
            return WorkerApiFp(configuration).deleteWorker(protocolId, registrationId, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImportWorker(id: string, options?: any) {
            return WorkerApiFp(configuration).getImportWorker(id, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} protocolId 
         * @param {string} registrationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorker(protocolId: string, registrationId: string, options?: any) {
            return WorkerApiFp(configuration).getWorker(protocolId, registrationId, options)(axios, basePath);
        },
        /**
         * 
         * @param {WorkerImport} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importWorkers(body: WorkerImport, options?: any) {
            return WorkerApiFp(configuration).importWorkers(body, options)(axios, basePath);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {string} [companyId] 
         * @param {Array<'waiting' | 'started' | 'success' | 'fail'>} [statuses] 
         * @param {Date} [startedAtMin] 
         * @param {Date} [startedAtMax] 
         * @param {Date} [finishedAtMin] 
         * @param {Date} [finishedAtMax] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {'startedAt' | 'finishedAt' | 'createdAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listImportsWorkers(ids?: Array<string>, companyId?: string, statuses?: Array<'waiting' | 'started' | 'success' | 'fail'>, startedAtMin?: Date, startedAtMax?: Date, finishedAtMin?: Date, finishedAtMax?: Date, createdAtMin?: Date, createdAtMax?: Date, sort?: 'startedAt' | 'finishedAt' | 'createdAt', order?: 'ASC' | 'DESC', offset?: number, limit?: number, options?: any) {
            return WorkerApiFp(configuration).listImportsWorkers(ids, companyId, statuses, startedAtMin, startedAtMax, finishedAtMin, finishedAtMax, createdAtMin, createdAtMax, sort, order, offset, limit, options)(axios, basePath);
        },
        /**
         * 
         * @param {Array<string>} [ids] List of strings in format &#x60;{protocolId}--{registrationId}&#x60;, separated by &#x60;--&#x60;. Example: &#x60;546d53af-52ef-4ce5-a2f6-0ee19b668d19--6aaca3b5-6526-48c5-b092-4ba89be8f77e&#x60; 
         * @param {string} [companyId] 
         * @param {Array<string>} [protocolIds] 
         * @param {Array<string>} [registrationIds] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkers(ids?: Array<string>, companyId?: string, protocolIds?: Array<string>, registrationIds?: Array<string>, offset?: number, limit?: number, options?: any) {
            return WorkerApiFp(configuration).listWorkers(ids, companyId, protocolIds, registrationIds, offset, limit, options)(axios, basePath);
        },
    };
};

/**
 * WorkerApi - object-oriented interface
 * @export
 * @class WorkerApi
 * @extends {BaseAPI}
 */
export class WorkerApi extends BaseAPI {
    /**
     * 
     * @param {string} protocolId 
     * @param {string} registrationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkerApi
     */
    public deleteWorker(protocolId: string, registrationId: string, options?: any) {
        return WorkerApiFp(this.configuration).deleteWorker(protocolId, registrationId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkerApi
     */
    public getImportWorker(id: string, options?: any) {
        return WorkerApiFp(this.configuration).getImportWorker(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} protocolId 
     * @param {string} registrationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkerApi
     */
    public getWorker(protocolId: string, registrationId: string, options?: any) {
        return WorkerApiFp(this.configuration).getWorker(protocolId, registrationId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {WorkerImport} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkerApi
     */
    public importWorkers(body: WorkerImport, options?: any) {
        return WorkerApiFp(this.configuration).importWorkers(body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {string} [companyId] 
     * @param {Array<'waiting' | 'started' | 'success' | 'fail'>} [statuses] 
     * @param {Date} [startedAtMin] 
     * @param {Date} [startedAtMax] 
     * @param {Date} [finishedAtMin] 
     * @param {Date} [finishedAtMax] 
     * @param {Date} [createdAtMin] 
     * @param {Date} [createdAtMax] 
     * @param {'startedAt' | 'finishedAt' | 'createdAt'} [sort] 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkerApi
     */
    public listImportsWorkers(ids?: Array<string>, companyId?: string, statuses?: Array<'waiting' | 'started' | 'success' | 'fail'>, startedAtMin?: Date, startedAtMax?: Date, finishedAtMin?: Date, finishedAtMax?: Date, createdAtMin?: Date, createdAtMax?: Date, sort?: 'startedAt' | 'finishedAt' | 'createdAt', order?: 'ASC' | 'DESC', offset?: number, limit?: number, options?: any) {
        return WorkerApiFp(this.configuration).listImportsWorkers(ids, companyId, statuses, startedAtMin, startedAtMax, finishedAtMin, finishedAtMax, createdAtMin, createdAtMax, sort, order, offset, limit, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {Array<string>} [ids] List of strings in format &#x60;{protocolId}--{registrationId}&#x60;, separated by &#x60;--&#x60;. Example: &#x60;546d53af-52ef-4ce5-a2f6-0ee19b668d19--6aaca3b5-6526-48c5-b092-4ba89be8f77e&#x60; 
     * @param {string} [companyId] 
     * @param {Array<string>} [protocolIds] 
     * @param {Array<string>} [registrationIds] 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkerApi
     */
    public listWorkers(ids?: Array<string>, companyId?: string, protocolIds?: Array<string>, registrationIds?: Array<string>, offset?: number, limit?: number, options?: any) {
        return WorkerApiFp(this.configuration).listWorkers(ids, companyId, protocolIds, registrationIds, offset, limit, options)(this.axios, this.basePath);
    }

}
